// Subscribe to a media query via `useSyncExternalStore` — the correct primitive
// for an external store subscription (react-useeffect-discipline 3.3), no effect
// needed. Drives the reader's responsive original pane: inline column on wide
// screens, a Sheet on narrow ones.

import { useSyncExternalStore } from "react";

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const list = window.matchMedia(query);
      list.addEventListener("change", onChange);
      return () => {
        list.removeEventListener("change", onChange);
      };
    },
    () => window.matchMedia(query).matches,
    () => false,
  );
}
